import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';

const formatToDateTime = (value) => {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
        return null;
    }

    const day = String(date.getDate()).padStart(2, '0'); 
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear(); 
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${month}/${day}/${year} ${hours}:${minutes}`;
};

const columns = [
    { id: 'id', label: 'id', minWidth: 170 },
    { id: 'name', label: 'Name', minWidth: 100 },
    { id: 'labid', label: 'Labid', minWidth: 100 },
    { id: 'onboarded', label: 'onboarded', minWidth: 170, format: formatToDateTime},
    { id: 'enabled', label: 'Enabled', minWidth: 100 },
    { id: 'testing', label: 'Testing', minWidth: 100 },
    { id: 'functionalIncomingMessages', label: 'Functional Incoming Messages', minWidth: 100 },
    { id: 'functionalOutgoingMessages', label: 'Functional Outgoing Messages', minWidth: 100 },
    { id: 'technicalIncomingMessages', label: 'Technical Incoming Messages', minWidth: 100 },
    { id: 'technicalOutgoingMessages', label: 'Technical Outgoing Messages', minWidth: 100 },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.yellow.main,
        color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#FDF2E7',
    },
}));

export default function StickyHeadTable({data}) {


    return (
        <Paper sx={{ overflow: 'hidden', width: '90%', marginBottom: '2rem' }}>
            <TableContainer sx={{ maxHeight: '100%' }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
            {/* First header row: Grouping cells */}
            <StyledTableRow>
              <StyledTableCell align="center" rowSpan={2}>ID</StyledTableCell>
              <StyledTableCell align="center" rowSpan={2}>Name</StyledTableCell>
              <StyledTableCell align="center" rowSpan={2}>Labid</StyledTableCell>
              <StyledTableCell align="center" rowSpan={2}>Onboarded</StyledTableCell>
              <StyledTableCell align="center" rowSpan={2}>Enabled</StyledTableCell>
              <StyledTableCell align="center" rowSpan={2}>Testing</StyledTableCell>
              <StyledTableCell align="center" colSpan={2}>Functional Messages</StyledTableCell>
              <StyledTableCell align="center" colSpan={2}>Technical Messages</StyledTableCell>
            </StyledTableRow>
            {/* Second header row: Sub-headers for grouped columns */}
            <StyledTableRow>
              <StyledTableCell align="center">Incoming</StyledTableCell>
              <StyledTableCell align="center">Outgoing</StyledTableCell>
              <StyledTableCell align="center">Incoming</StyledTableCell>
              <StyledTableCell align="center">Outgoing</StyledTableCell>
            </StyledTableRow>
          </TableHead>
                    <TableBody>
                        { data ? (data?.map((row) => {
                                return (
                                    <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            return (
                                                <StyledTableCell key={column.id} align={'center'}>
                                                    {column.format
                                                        ? column.format(value)
                                                        : value}
                                                </StyledTableCell>
                                            );
                                        })}
                                    </StyledTableRow>
                                );
                            })) : (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={columns.length} align="center">
                                        No data available
                                    </StyledTableCell>
                                </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}